import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import axios from "axios";
import { url } from "../../../Constant";
import { useAuth } from "../../../Context/AuthProvider";
import { toast } from "react-toastify";

// const columns = [
//     {
//         name: "SERIES",
//         selector: "id",
//       },
//   {
//     name: "",
//     cell: (row) => (
//         <div className="">
//           <div className="uk-inline">
//             <img src={row.pic}/>
//           </div>
//         </div>
//       ),
//   },
//   {
//     name: "NAME",
//     selector: "name",
//   },
//   {
//     name: "WORK NUMBER",
//     selector: "workNumber",
//   },
//   {
//     name: "MOBILE NUMBER",
//     selector: "mobileNumber",
//   },
//   {
//     name: "EMAIL",
//     selector: "email",
//   },
//   {
//     name: "ROLE",
//     selector: "role",
//   },
//   {
//     name: "TEAMS",
//     selector: "team",
//   },
//   {
//     name: "Created",
//     selector: "created",
//   },
//   {
//     name: "UPDATED",
//     selector: "updated",
//   },
//   {
//     name: "",
//     cell: (row) => (
//       <div className="">
//         <div className="uk-inline">
//           <button
//             className="iconTble actionDropDownBtn"
//             type="button"
//             uk-toggle={`target: #drop-menu-${row.id}`}
//             aria-haspopup="true"
//             aria-expanded="false"
//           >
//             <img
//               src="./assets/images/zong/overflow-menu--vertical.svg"
//               uk-svg=""
//               alt="Menu"
//             />
//           </button>

//           <div
//             id={`drop-menu-${row.id}`}
//             uk-dropdown="mode: click"
//             className="actionDropDown"
//           >
//             <ul className="uk-nav uk-dropdown-nav mainauto">
//               <li>
//                 <a href="#">
//                   <span>
//                     <img
//                       src="./assets/images/zong/download.svg"
//                       uk-svg=""
//                       alt="Download"
//                     />
//                     <span>Download</span>
//                   </span>
//                 </a>
//               </li>
//               <li>
//                 <a href="#">
//                   <span className="DeletBtn">
//                     <img
//                       src="./assets/images/zong/trash-can.svg"
//                       uk-svg=""
//                       alt="Delete"
//                     />
//                     <span>Delete</span>
//                   </span>
//                 </a>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </div>
//     ),
//   },
// ];

const User = () => {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const [searchText, setSearchText] = useState("");
  const [users, setUsers] = useState();

  const columns = [
    // {
    //   name: "S.No",
    //   selector: (row) => row.user_id,
    //   // sortable: true,
    // },
    {
      name: "Name",
      selector: (row) => row.name,
      // sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      // sortable: true,
    },
    {
      name: "Status",
      selector: (row) => (
        <div>
          <button
            className={
              row.status === 1 ? "btn-design greenColor" : "btn-design redColor"
            }
            onClick={() => handleStatus(row)}
          >
            {row.status === 0 ? "De-Activated" : "Activated"}
          </button>
        </div>
      ),
    },
    {
      name: "",
      cell: (row) => (
        <div
          className="uk-float-right"
          style={{ "text-align": "end", width: "100%" }}
        >
          <div className="uk-inline">
            <button
              className="iconTble actionDropDownBtn TableActionIcon"
              type="button"
              onClick={() => {
                // (window.location.href = `/edit-extension/${row.extension_number}`)
                window.location.href = `/edit-user/${row.user_id}`;
              }}
            >
              {/* <img
                src="./assets/images/zong/trash-can.svg"
                uk-svg=""
                alt="Delete"
              /> */}
              <span uk-icon="icon: pencil"></span>
            </button>
            {/* <button className="iconTble actionDropDownBtn TableActionIcon" type="button">
            <img src="./assets/images/zong/trash-can.svg" uk-svg="" alt="Delete" />
          </button> */}
          </div>
        </div>
      ),
    },
    // {
    //   name: "",
    //   cell: (row) => (
    //     <div className="">
    //       <div className="uk-inline">
    //         <button
    //           className="iconTble actionDropDownBtn"
    //           type="button"
    //           uk-toggle={`target: #drop-menu-${row.user_id}`}
    //           aria-haspopup="true"
    //           aria-expanded="false"
    //         >
    //           <img
    //             src="./assets/images/zong/overflow-menu--vertical.svg"
    //             uk-svg=""
    //             alt="Menu"
    //           />
    //         </button>

    //         <div
    //           id={`drop-menu-${row.user_id}`}
    //           uk-dropdown="mode: click"
    //           className="actionDropDown"
    //         >
    //           <ul className="uk-nav uk-dropdown-nav mainauto">
    //             <li
    //             // onClick={() => {
    //             //   // navigate("/edit-user", {
    //             //   //   state: row,
    //             //   // });
    //             //   window.location.href = `/edit-user/${row.user_id}`;
    //             // }}
    //             >
    //               <a href={`/edit-user/${row.user_id}`}>
    //                 <span>
    //                   <img
    //                     src="./assets/images/zong/download.svg"
    //                     uk-svg=""
    //                     alt="Download"
    //                   />
    //                   <span> Edit</span>
    //                 </span>
    //               </a>
    //             </li>
    //             {/* <li>
    //               <a href="#">
    //                 <span>
    //                   <img
    //                     src="./assets/images/zong/download.svg"
    //                     uk-svg=""
    //                     alt="Download"
    //                   />
    //                   <span>Download</span>
    //                 </span>
    //               </a>
    //             </li>
    //             <li>
    //               <a href="#">
    //                 <span className="DeletBtn">
    //                   <img
    //                     src="./assets/images/zong/trash-can.svg"
    //                     uk-svg=""
    //                     alt="Delete"
    //                   />
    //                   <span>Delete</span>
    //                 </span>
    //               </a>
    //             </li> */}
    //           </ul>
    //         </div>
    //       </div>
    //     </div>
    //   ),
    // },
  ];
  const handleStatus = (row) => {
    axios
      .post(
        url + "update-status",
        {
          status: row.status == 1 ? 0 : 1,
          user_id: row.user_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(function (result) {
        if (result.data.status === true) {
          toast.success("Status Changed Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1200,
          });
          setTimeout(() => {
            getUserList();
          }, 1500);
        }
      });
  };

  const getUserList = () => {
    axios
      .post(
        url + "view-user",
        { vpbx_id: auth.vpbx_id },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          setUsers(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
        // Handle other errors (e.g., network errors)
      });
  };

  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };

  const filteredDataUser = users?.filter((UserData) => {
    return (
      UserData.name.toLowerCase().includes(searchText.toLowerCase()) ||
      UserData.email.toLowerCase().includes(searchText.toLowerCase())
    );
  });

  useEffect(() => {
    getUserList();
  }, []);
  const handleExportData = () => {
    // console.log("Exporting data...");
    const exportedData = filteredDataUser.map((UserData) => ({
      SERIES: UserData.id,
      name: UserData.name,
      "WORK NUMBER": UserData.workNumber,
      "MOBILE NUMBER": UserData.mobileNumber,
      EMAIL: UserData.email,
      ROLE: UserData.role,
      TEAMS: UserData.team,
      CREATED: UserData.created,
      UPDATED: UserData.updated,
    }));

    const csvContent =
      "data:text/csv;charset=utf-8," + convertToCSV(exportedData);
    const jsonData = JSON.stringify(exportedData, null, 2);

    const downloadLink = document.createElement("a");
    downloadLink.href = csvContent;
    downloadLink.download = "exported_data.csv";
    downloadLink.click();
  };

  const convertToCSV = (data) => {
    const header = Object.keys(data[0]).join(",");
    const rows = data.map((item) => Object.values(item).join(","));
    return [header, ...rows].join("\n");
  };

  return (
    <div className="ImcomingCallMain RoutingMain">
      <div className="uk-grid" uk-grid="">
        <div className="uk-width-1-2">
          <div className="uk-text-left">
            {/* <div className="MainHeading">
                <h6>Department</h6>
                <div className="uk-text-left">
                <div className="CustomSearch">
                  <form className="uk-search uk-search-default">
            

                    <input
                      className="uk-search-input"
                      type="text"
                      placeholder="Search by name or number"
                      value={searchText}
                      onChange={handleSearch}
                    />
                  </form>
                </div>
              </div>
              </div> */}
          </div>
        </div>

        <div className="uk-width-1-2">
          <div className="uk-text-right">
            <span>
              <div className="uk-inline uk-text-left">
                <Link className="exportData-button NewFlow" to="/add-user">
                  Add user
                </Link>
                {/* <button
                  className="exportData-button"
                  onClick={handleExportData}
                >
                  Export Data
                </button> */}
              </div>
            </span>
            <span className="primary-color"></span>
          </div>
        </div>
      </div>

      <DataTable columns={columns} data={filteredDataUser} pagination />
    </div>
  );
};

export default User;
